<template>
    <div v-if="currentUserChildsData && currentUserChildsData.length > 0">
        <multiselect
            :value="currentUser"
            :custom-label="customLabel"
            :closeOnSelect="true"
            :max-height="600"
            :style="{'font-size': '12px'}"
            :multiple="false"
            :option-height="33"
            :placeholder="placeholder"
            :preserve-search="true"
            :class="[validatorClass]"
            :options="currentUserChildsData"
            :searchable="true"
            :allow-empty="true"
            open-direction="bottom"
            id="key_account"
            @input="onInput"
        >

        <template slot="option" slot-scope="props">
            <div class="box" v-if="props">
                <p>{{props.option}}</p>
            </div>
        </template>

        <template slot="option" slot-scope="props">
            <div class="box" v-if="props && props.option">
                <!--<div class="icon">
                    <img :src="props.option.iconURL">
                </div>-->
                <div class="content">
                    <div class="name">
                        {{customLabel(props.option)}}
                    </div>
                    <div class="address" v-if="props.option.address">
                        <small><strong>Coutry: </strong>{{propOrMiss(props.option.address.country) }}</small>
                        <small><strong>City: </strong>{{ propOrMiss(props.option.address.city) }} {{ propOrMiss(props.option.address.postcode)}}</small>
                        <small><strong>Street: </strong>{{ propOrMiss(props.option.address.street) }} {{ propOrMiss(props.option.address.houseNumber)}}</small>
                    </div>
                </div>
            </div>
        </template>

        </multiselect>
    </div>
</template>

<script type="text/babel">
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
    name: "KeyAccountPicker",
    data () {
        return {
            user: ''
        }
    },
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        validator: {
            type: Object,
            default: () => {}
        },
        currentUser: {
            type: Object
        },
        users:{
            type: Array
        },
        placeholder:{
            type: String,
            default: 'Select key account'
        }
    },
    components: {
        Multiselect
    },
    methods: {
        customLabel (key_account = {}) {
          const { person = {} } = key_account;
          const { firstName, lastName } = person;

          return `${firstName} ${lastName}`
        },
        propOrMiss (v){
          return v || '-';
        },
        onInput (v){
          this.$emit("changeUser", v);
        }
    },
    computed: {
        ...mapGetters({
            getUserChilds: "getUserChilds"
        }),
        currentUserChildsData(){
          if(this.users){
            return this.users;
          }

          return this.getUserChilds;
        },
        validatorClass() {
            if (!this.validator) {
                return {};
            }
            return {
                invalid: this.validator.$invalid,
                dirty: this.validator.$dirty,
                valid: !this.validator.$invalid
            };
        }
    }
};
</script>

<style lang="scss" scoped>
  /deep/ {
    input::-webkit-input-placeholder {
        color: lightgray;
    }

   .multiselect,
   .multiselect__input,
   .multiselect__single {
     font-size: 13px;
   }

   .multiselect__tags,
   .multiselect__single {
      border-radius: .2rem;
      border-color: #ced4da;
      padding-top: 0;
      font-size: 13px;
      min-height: 31px;
      line-height: 31px;
    }

    .multiselect{
      &.multiselect--active{
        .multiselect__tags, .multiselect__single{
          border-color: #8ca3f1;
        }
      }
    }

    .multiselect__input,
    .multiselect__single,
    .multiselect__placeholder{
      min-height: 31px;
      margin-bottom: 0;
      padding-top: 0;
      line-height: 31px;

    }

    .multiselect__select{
      height: 31px;
    }

    .multiselect__input,
    .multiselect__placeholder{
      color: lightgray;
    }
  }

  .invalid.dirty {
      & /deep/ .multiselect__tags {
          border-color: red;
      }
      & /deep/ .multiselect__input::-webkit-input-placeholder {
          color: lightgray;
      }
  }
  .box{
      display: flex;
      .icon{
          width: 40px;
          img{
              max-width: 40px;
              height: auto;
          }
          display: inline-block;
          margin-right: 5px;
      }

      .content{
          .name{
            font-weight: bold;
            font-size: 13px;
          }
          display: inline-block;
      }
      small{
          display: block;
      }
  }
</style>
